<template>
  <div>
    <img @click="toggle()" class="hamburger2" src="@/assets/img/dots.svg" />
    <div class="side_menu none">
      <div
        class="navs"
        v-if="!disabled"
        :class="{ slideIn: hamburger, slideOut: !hamburger }"
      >
        <div class="nav-links">
          <div
            v-for="(nav, index) in navs"
            :key="index"
            class="nav"
            :class="{ active: activeNav == nav.name }"
          >
            <p :ref="nav.name" @click="checkIfChildren(nav)">
              {{ nav.name }}
              <img
                class="toggle"
                v-if="nav.children"
                :class="{ active: showChildren == nav.name }"
                src="@/assets/img/toggle.svg"
              />
            </p>
            <div v-if="showChildren == nav.name" class="sub-navs">
              <template v-for="(childNav, childIndex) in nav.children">
                <div class="sub-nav" :key="childIndex">
                  <p
                    :class="{ active: childName == childNav.name }"
                    @click="goTo('/event/' + $route.params.id + childNav.url)"
                  >
                    {{ childNav.name }}
                  </p>
                </div>
              </template>
            </div>
          </div>
          <div class="nav">
            <p>
              <button
                @click="goTo('/event/' + $route.params.id + '/content')"
                class="btn text_btn edit-btn"
              >
                Edit event
              </button>
            </p>
          </div>
          <div class="nav">
            <p>
              <button
                @click="goTo('/event/' + $route.params.id + '/preview')"
                class="btn text_btn"
              >
                Preview
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManagementMenu",
  components: {},
  props: ["activeNav", "childName"],
  data() {
    return {
      hamburger: false,
      disabled: true,
      navs: [
        {
          name: "Event",
          url: "/event/content/",
          children: [
            {
              name: "Dashboard",
              url: "/management",
            },
            {
              name: "Details",
              url: "/details",
            },
            {
              name: "Venues",
              url: "/venues",
            },
            {
              name: "Speakers",
              url: "/speakers",
            },
            {
              name: "Agenda",
              url: "/agenda",
            },
            {
              name: "Sponsors",
              url: "/sponsors",
            },
            {
              name: "Tickets",
              url: "/tickets",
            },
            {
              name: "Pages",
              url: "/pages",
            },
            {
              name: "Design",
              url: "/design",
            },
            {
              name: "Reports",
              url: "/reports",
            },
            {
              name: "Manage",
              url: "/manage",
            },
          ],
        },
        {
          name: "Attendees",
          url: null,
          children: [
            {
              name: "View Attendees",
              url: "/attendees",
            },
            {
              name: "Emails to Attendees",
              url: "/attendees/emails",
            },
            {
              name: "View Guests",
              url: "/guestlist",
            },
          ],
        },
        {
          name: "Orders",
          url: null,
          children: [
            {
              name: "View Orders",
              url: "/orders",
            },
            {
              name: "Create Order",
              url: "/attendees/add",
            },
            {
              name: "Create Guest",
              url: "/guest/add",
            },
          ],
        },
        {
          name: "Check-In",
          url: null,
          children: [
            {
              name: "Badges",
              url: "/badges",
            },
            {
              name: "Check-In Status",
              url: "/check-in",
            },
          ],
        },
        {
          name: "Exhibitors",
          url: null,
          children: [
            {
              name: "Create Exhibitor",
              url: "/exhibitors/create",
            },
            {
              name: "View Exhibitors",
              url: "/exhibitors",
            },
            {
              name: "Exhibitor Inquiries/Leads",
              url: "/exhibitors/leads",
            },
            {
              name: "Exhibitor Tickets",
              url: "/exhibitors/tickets",
            },
            {
              name: "Badges",
              url: "/badges",
            },
          ],
        },
        {
          name: "All Events",
          url: null,
          children: [
            {
              name: "Dashboard",
              url: "/all/management",
            },
            {
              name: "View Events",
              url: "/events",
            },
            {
              name: "View Venues",
              url: "/all/venues",
            },
            {
              name: "View Attendees",
              url: "/all/attendees",
            },
            {
              name: "View Attendee Orders",
              url: "/tbd",
            },
            {
              name: "View Exhibitors",
              url: "/all/exhibitors",
            },
            {
              name: "View Exhibitor Orders",
              url: "/tbd",
            },
            {
              name: "View Speakers",
              url: "/all/speakers",
            },
            {
              name: "View Sponsors",
              url: "/all/sponsors",
            },
            {
              name: "Reports",
              url: "/all/reports",
            },
          ],
        },
      ],
      showChildren: null,
    };
  },
  mounted() {},
  created() {
    if (window.innerWidth >= 700) {
      this.disabled = false;
    }
    this.$nextTick(() => {
      if (this.childName) {
        this.showChildren = this.childName;
        this.$refs[this.activeNav][0].click();
      }
    });
  },
  firestore() {
    return {};
  },
  methods: {
    toggle() {
      this.disabled = false;
      let sideMenu = document.querySelector(".side_menu");
      if (this.hamburger) {
        setTimeout(() => {
          sideMenu.className = "side_menu none";
          setTimeout(() => {
            sideMenu.style.backgroundColor = "";
          }, 400);
        }, 200);
      } else {
        setTimeout(() => {
          sideMenu.className = "side_menu display";
          setTimeout(() => {
            sideMenu.style.backgroundColor = "#f7f7f7";
          }, 300);
        }, 100);
      }
      this.hamburger = !this.hamburger;
    },
    checkIfChildren(nav) {
      if (nav.children) {
        if (this.showChildren == nav.name) {
          this.showChildren = null;
        } else {
          this.showChildren = nav.name;
        }
      } else {
        this.goTo("/event/" + this.$route.params.id + nav.url);
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scope>
.side_menu {
  width: 250px;
  top: 0;
  overflow: hidden;
  overflow-y: scroll;
  height: 100% !important;
  padding-top: 150px;
  position: fixed;
  @media screen and (max-width: 700px) {
    display: flex;
    z-index: 2;
    padding-top: 163px;
  }
  .navs {
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 700px) {
      display: flex;
      justify-content: space-between;
      background: #f7f7f7;
      animation: slide-in-div 0.5s ease;
      z-index: 1;
      background: #f7f7f7;
      .nav-links {
        width: 100%;
      }
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      border-bottom: 2px solid #eaeaea;
      background: #f7f7f7;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: white;
      }

      &.active {
        background-color: white;

        p {
          color: #fba500;
        }
      }

      p {
        margin: 0;
        padding: 15px 20px;
        width: 100%;
        position: relative;
        transition: color 0.3s;

        .toggle {
          height: 12px;
          position: absolute;
          right: 20px;
          opacity: 0.3;
          top: 50%;
          transform: translateY(-50%);
          transition: transform 0.3s;

          &.active {
            transform: rotate(180deg) translateY(50%);
          }
        }
      }

      .sub-nav {
        margin-left: 10px;
        margin-bottom: 10px;

        p {
          padding: 0 20px;
          font-size: 15px;
          color: black;
          &:hover,
          &.active {
            color: #fba500;
          }
        }
      }
    }
  }
}

.hamburger2 {
  display: none;
  height: 15px;
  cursor: pointer;
  filter: brightness(0);
  @media screen and (max-width: 800px) {
    display: block;
    margin: 0px 0 0 7px;
    position: fixed;
    z-index: 99;
  }
}

@media screen and (max-width: 700px) {
  .navs.slideOut {
    overflow-y: hidden;
    transform: translateX(-120%);
    animation: slide-out-div 0.4s ease;
  }
  .none {
    display: none;
  }
  .display {
    display: block;
  }
  .above {
    z-index: 99;
  }
}

@keyframes slide-in-div {
  0% {
    transform: translateX(-100%);
    visibility: hidden;
  }
  100% {
    transform: translateX(0%);
    visibility: visible;
    // background: #f7f7f7;
  }
}

@keyframes slide-out-div {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-120%);
  }
}
</style>
